/* eslint-disable max-len */
import React from 'react'
import { connect } from 'react-redux'
import { Nav, NavItem } from 'react-bootstrap'
import { Popup, Flex } from '@leverege/ui-elements'
import { Switch, Route } from 'react-router-dom'
import classnames from 'classnames'
import RouteMatcher from '~/RouteMatcher'
import ContactsScreen from './ContactsScreen'
import SystemInfoScreen from './SystemInfoScreen'
import SystemUsersScreen from './SystemUsersScreen'
import DevicesScreen from '~/screens/device/DevicesScreen'
import InterfaceDevicesTypeScreen from '../device/InterfaceDevicesTypeScreen'
import SystemHistoryScreen from '~/screens/history/SystemHistoryScreen'
import SystemEventScreen from '~/screens/history/SystemEventScreen'
import SystemEnumScreen from '~/screens/enum/SystemEnumScreen'
import { View } from '~/views';

import S from './style.css'
import SystemTranslationScreen from './SystemTranslationScreen';
import { BlueprintActions } from '../../actions';
import SystemRulesScreen from './SystemRulesScreen';
import SystemRuleScreen from './SystemRuleScreen';

class SystemHomeScreen extends React.Component {

  static routes = [
    <Route key="/project/:projectId/system/:systemId" path="/project/:projectId/system/:systemId" exact component={SystemInfoScreen} />,
    <Route key="/project/:projectId/system/:systemId/" path="/project/:projectId/system/:systemId/" exact component={SystemInfoScreen} />,
    <Route key="/project/:projectId/system/:systemId/info" path="/project/:projectId/system/:systemId/info" exact={false} component={SystemInfoScreen} />,
    <Route key="/project/:projectId/system/:systemId/info" path="/project/:projectId/system/:systemId/translation" exact={false} component={SystemTranslationScreen} />,
    <Route key="/project/:projectId/system/:systemId/history" path="/project/:projectId/system/:systemId/history" exact={undefined} component={SystemHistoryScreen} />,
    <Route key="/project/:projectId/system/:systemId/event" path="/project/:projectId/system/:systemId/event" exact={undefined} component={SystemEventScreen} />,
    <Route key="/project/:projectId/system/:systemId/access" path="/project/:projectId/system/:systemId/access" exact={false} component={SystemUsersScreen} />,
    <Route key="/project/:projectId/system/:systemId/contact" path="/project/:projectId/system/:systemId/contact" exact component={ContactsScreen} />,
    <Route key="/project/:projectId/system/:systemId/resourceEnum" path="/project/:projectId/system/:systemId/resourceEnum" exact component={SystemEnumScreen} />,
    <Route key="/project/:projectId/system/:systemId/resourceEnum/id" path="/project/:projectId/system/:systemId/resourceEnum/:enumType" component={SystemEnumScreen} />,
    <Route key="/project/:projectId/system/:systemId/rule" path="/project/:projectId/system/:systemId/rule" exact component={SystemRulesScreen} />,
    <Route key="/project/:projectId/system/:systemId/rule/id" path="/project/:projectId/system/:systemId/rule/:ruleId" component={SystemRuleScreen} />,
    
    <Route key="/project/:projectId/system/:systemId/device" path="/project/:projectId/system/:systemId/device" exact={false} component={DevicesScreen} />,
    <Route key="/project/:projectId/system/:systemId/device/:deviceId" path="/project/:projectId/system/:systemId/device/:deviceId" exact={false} component={DevicesScreen} />,
    
    <Route key="/project/:projectId/system/:systemId/blueprint/:blueprintId" path="/project/:projectId/system/:systemId/blueprint/:blueprintId/device" exact={false} render={props => <InterfaceDevicesTypeScreen key={props.location.pathname} {...props} />} />,
    <Route key="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId" path="/project/:projectId/system/:systemId/blueprint/:blueprintId/device/:deviceId" exact={false} component={DevicesScreen} />,
  ]

  constructor( props ) {
    super( props );

    this.routeMatcher = new RouteMatcher( SystemHomeScreen.routes, { missComponent : null } )

  }

  componentDidMount() {
    const { match, dispatch } = this.props
    dispatch( BlueprintActions.listBlueprints( match.params.projectId ) )
  }

  onTabSelected = ( key, evt ) => {
    const { history, match : { params : { projectId, systemId } } } = this.props
    history.push( `/project/${projectId}/system/${systemId}/${key}` )
  }

  onPopupTabSelected = ( { data } ) => {
    const { history, match : { params : { projectId, systemId } } } = this.props
    history.push( `/project/${projectId}/system/${systemId}/${data}` )
  }

  render() {
    const { blueprints, match : { params }, location } = this.props

    const matchResult = this.routeMatcher.find( location )
    const { matchIndex } = matchResult

    const keys = [
      'info',
      'info',
      'info',
      'translation',
      'history',
      'event',
      'access',
      'contact',
      'resourceEnum',
      'resourceEnum',
      'rule',
      'rule',
      'device',
      'device',
      'blueprint/:blueprintId/device'
    ]

    let activeKey = keys[matchIndex], bp
    if ( activeKey === 'blueprint/:blueprintId/device' ) {
      const bpId = location.pathname.split( '/' ).slice( -2 )[0]
      bp = blueprints[bpId]
      activeKey = `blueprint/${bpId}/device`
    }

    return (
      <View style={{ display : 'flex', flexDirection : 'column', overflow : 'hidden' }}>
        <Nav bsStyle="tabs" activeKey={activeKey} onSelect={this.onTabSelected}>
          <NavItem eventKey="info">Info</NavItem>
          <NavItem eventKey="device">Devices</NavItem>
          <NavItem eventKey="access">Access</NavItem>
          <NavItem eventKey="contact">Contacts</NavItem>
          <NavItem eventKey="history">History</NavItem>
          <NavItem eventKey="event">Events</NavItem>
          <NavItem eventKey="resourceEnum">Enums</NavItem>
          <NavItem eventKey="translation">Translation</NavItem>
          <NavItem eventKey="rule">Rules</NavItem>
          <Popup
            className={classnames( S.typePopup, S.win )}
            title={(
              <Flex className={classnames( S.typePopupTitle, S.win )}>
                <div>{( bp && bp.name ) || 'Devices By Type'}</div>
                <i className="fa fa-ellipsis-v" />
              </Flex>
            )}>
            {blueprints && Object.values( blueprints ).filter( bp => bp.projectId === params.projectId ).map(
              bp => ( <Popup.Item onClick={this.onPopupTabSelected} eventData={`blueprint/${bp.id}/device`} key={`blueprint/${bp.id}/device`}>{bp.name || bp.id}</Popup.Item> )
            )}
          </Popup>
        </Nav>

        <div style={{ flex : 1, overflow : 'auto', position : 'relative' }}>
          <Switch>
            {SystemHomeScreen.routes}
          </Switch>
        </div>
      </View>
    )
  }
}

export default connect( ( state, props ) => ( {
  blueprints : state.blueprints && state.blueprints.index
} ) )( SystemHomeScreen )
